import { useParams } from 'react-router-dom'

import { useUserContext } from '../context'
import { findInternalUpdate, INTERNAL_UPDATES } from '../internal-updates'
import Error404 from './error-404'
import { UpdatePage, UpdatesOverview } from './product-updates'

// Interne Updates fuer das Aivy-Team. Nur mit Login (routes) und nur fuer
// __admin, alle anderen sehen dieselbe 404 wie bei einer unbekannten Seite.

export function InternalUpdatesOverview() {
  const { isAdmin } = useUserContext()

  if (!isAdmin) return <Error404 />

  return (
    <UpdatesOverview
      updates={INTERNAL_UPDATES}
      basePath='/internal/updates'
      title='Interne Updates'
      description='Neuerungen für das Aivy-Team.'
      intro='Was sich in Produkt, Backend und Tools getan hat, nach Themen sortiert, mit Stand je Umgebung und offenen Punkten. Nur für Aivy-Admins sichtbar.'
      empty='Noch keine internen Updates.'
      noindex
    />
  )
}

export function InternalUpdate() {
  const { isAdmin } = useUserContext()
  const { slug } = useParams()

  if (!isAdmin) return <Error404 />

  return (
    <UpdatePage
      update={findInternalUpdate(slug)}
      basePath='/internal/updates'
      suffix='Interne Updates'
      noindex
    />
  )
}
